module.exports = __webpack_public_path__ + "static/img/img3.fd1f947.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/course/img3.jpg
// module id = Ai+2
// module chunks = 1